import { Component, SimpleChange } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { PartnersService } from 'src/app/services/partners.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreatePartnersComponent } from '../create-partners/create-partners.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
@Component({
    selector: 'app-list-partners',
    templateUrl: './list-partners.component.html',
    styleUrls: ['./list-partners.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        CreatePartnersComponent,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListPartnersComponent {
  partners: UserDTO[] = [];
  originalPartners: UserDTO[] = [];
  filterValue: string = 'option1';
  currentPage: number = 1;
  recordsPerPage: number = 10;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'totalCustomers',
    'totalStaff',
  ];
  isFilteredByStatus: boolean = false;
  selectedPartner: UserDTO | any = {} as UserDTO;
  isConfirmationModalOpen: boolean = false;
  requestLong: SimpleRequestDTO = {} as SimpleRequestDTO ;
  alert: Alert = {} as Alert;

  constructor(
    private partnerService: PartnersService,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Partners);
    this.partnerService.getListPartners().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListPartners(Data);
        } else {
          this.HandleGetListPartnersError(StatusCode);
        }
      },
      (error) => {
        this.errorMessage();
      }
    );
    document.documentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  get pages(): number[] {
    const start = Math.max(
      1,
      this.currentPage - Math.floor(this.pagesToShow / 2)
    );
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage * 10 < this.partners.length) {
      this.currentPage++;
    }
  }

  getRange(): string {
    const startIndex = (this.currentPage - 1) * 10 + 1;
    const endIndex = Math.min(this.currentPage * 10, this.partners.length);
    return `${startIndex} - ${endIndex}`;
  }

  HandleGetListPartnersError(StatusCode: number) {
    this.errorMessage();
  }

  HandleGetListPartners(users: UserDTO[]) {
    this.partners = users;
    this.originalPartners = this.partners.slice();
    this.partners = this.originalPartners.filter((partner) => partner.userStatus === 0 || partner.userStatus === 1);
    this.totalPages = Math.ceil(this.partners.length / 10);
  }

  updatePagination(): void {
    if (!this.textoBusqueda) {
      this.totalPages = Math.ceil(this.partners.length / this.recordsPerPage);
    }
  
    const searchCriteria = this.textoBusqueda.split(',').map(criterio => criterio.trim().toLowerCase());
  
    const filteredList = this.partners.filter((item) =>
      this.camposBusqueda.some((field) => {
        const fieldValue = (item as any)[field];
        // Verificamos si el valor del campo no es undefined o null
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some((criterio) => fieldValue.toString().toLowerCase().includes(criterio));
        }
        return false; // Si es undefined o null, lo ignoramos
      })
    );
  
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPage = 1;
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  filterByStatus(status: number) {
    this.partners = this.originalPartners.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalPartners = this.partners.slice();
      this.isFilteredByStatus = true;
    }

    this.partners = this.originalPartners.filter((partner) => partner.userStatus === status);
    this.updatePagination();
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.partners = this.originalPartners.slice(); // Restaura la lista original
    this.partners = this.partners.filter(partner => partner.userStatus === 0 || partner.userStatus === 1);
    this.updatePagination();
  }

  setSelectedPartner(user: UserDTO) {
    this.selectedPartner = user;
  }

  setArchivedPartner(user: UserDTO) {
    this.selectedPartner = user;
    //this.selectedPartner.userStatus = this.isFilteredByStatus ? 0 : 2;
    this.selectedPartner['@userStatus'] = this.isFilteredByStatus ? 1 : 2;
  }

  toggleStatus(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalPartners.findIndex(cust => cust.userId === customer.userId);
    if (indice !== -1) {
      this.originalPartners[indice].userStatus = customer.userStatus;
    }
  }

  openConfirmationModal(user: UserDTO) {
    this.selectedPartner = user;
    this.isConfirmationModalOpen = true;
  }

  async closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    location.reload();
  }

  // Metodo para actualizar el estado de un cliente
  updatePartnerStatus(confirmed: boolean) {
    if (confirmed) {
      if (typeof this.selectedPartner['@userStatus'] === 'number') this.selectedPartner.userStatus = this.selectedPartner['@userStatus'];
      this.customerService.updateCustomerStatus(this.selectedPartner).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleUpdateCustomerStatus(Data);
          } else {
            this.HandleUpdateCustomerStatusError(StatusCode);
          }
        },
        (error) => {
          this.errorMessage();
        }
      );
    }
    else
    {
      location.reload();
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.errorMessage();
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.ClearCustomersPartner();
		this.alert = {
      alertMessage: ' Partner status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  ClearCustomersPartner() {
    
    this.requestLong.id = this.selectedPartner.userId;

    this.customerService.clearCustomersPartner(this.requestLong).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleClearCustomersPartner(Data);
        } else {
          this.HandleUpdateCustomerStatusError(StatusCode);
        }
      },
      (error) => {
        this.errorMessage();
      }
    );
  }

  async HandleClearCustomersPartner(customer: boolean) {
    this.errorMessage();
    await new Promise(resolve => setTimeout(resolve, 1));
    document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    await new Promise(resolve => setTimeout(resolve, 3000));
    location.reload();
  }

  navigateToPartnerCustomers(user: UserDTO) {
    //console.log("navigate to partner customers");
    //console.log(user);
    this.router.navigate(['/partners/partner-customers'], {
      relativeTo: this.route,
      state: { partnerData: user },
    });
  }

  errorMessage() {
		this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  navigateToPartnerView(partner: UserDTO) {
    //console.log("navigate to customer view");
    //console.log(partner);
    this.router.navigate(['/partners/view-partner', partner.userId]);
  }

  exportListPartnersToExcel() {
    this.partnerService.exportToExcelListPartners().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetFileError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

		this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetFileError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  navigateToCustomerUsers(customer: any) {
    this.router.navigate(['/partners/partner-staff'], {
      relativeTo: this.route,
      state: { customerData: customer },
    });
  }
}